export enum ScrollAreaScrollbarCssVars {
  /**
   * The scroll area thumb's height.
   * @type {number}
   */
  scrollAreaThumbHeight = '--scroll-area-thumb-height',
  /**
   * The scroll area thumb's width.
   * @type {number}
   */
  scrollAreaThumbWidth = '--scroll-area-thumb-width',
}
